/**
 * Created by user on 2018/5/16/016.
 */

import { gitRoot } from './core';

export = gitRoot
